import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

const API_PUBLIC_HOST = process.env.REACT_APP_CHANNEL_PUBLIC_API_PATH;

export const getGroupsData = params =>
  axios.get(`${API_HOST}/options/groupCreateMenu`, {
    params,
    withCredentials: true
  });

export const getShopsData = params =>
  axios.get(`${API_HOST}/options/shopCreateMenu`, {
    params,
    withCredentials: true
  });

export const getMenuGenre = params =>
  axios.get(`${API_HOST}/menu-genre/combobox-data`, {
    params,
    withCredentials: true
  });

export const getMenuSituation = params =>
  axios.get(`${API_HOST}/menu-situation/combobox-data`, {
    params,
    withCredentials: true
  });

export const getMenuUserTarget = params =>
  axios.get(`${API_HOST}/menu-user-target/combobox-data`, {
    params,
    withCredentials: true
  });

export const getShopsGochiKidData = params =>
  axios.get(`${API_PUBLIC_HOST}/gochi-kid/home-page/shops`, {
    params
  });

export const getMenusGochiKidData = params =>
  axios.get(`${API_PUBLIC_HOST}/gochi-kid/home-page/menus`, {
    params
  });

export const getGroupsSpecialGochiKidData = params =>
  axios.get(`${API_PUBLIC_HOST}/gochi-kid/home-page/group-special`, {
    params
  });

export const getShopsGroupSpecialGochiKidData = (gochiKidGroupId, params) =>
  axios.get(
    `${API_PUBLIC_HOST}/gochi-kid/home-page/v2/group-special/${gochiKidGroupId}/shops`,
    {
      params
    }
  );

export const getDonateHistoryGochiKidData = params =>
  axios.get(`${API_HOST}/gochi-kid/donate-history`, {
    params
  });
